import { Routes } from '@angular/router'
import { IsSuperAdminOrGuruAdminGuard } from "../auth/is-super-admin-or-guru-admin-guard"
import { EnrollmentSearchGuard } from "../auth/enrollment-search-guard"
import { ReportsLayoutComponent } from './components/layout/reports-layout.component'
//import { MyClientsComponent } from './components/my-clients/my-clients.component'

import { ClientsReportComponent } from './components/clients-report/clients-report.component'

//import { EnrollmentsCountComponent } from './components/my-clients/enrollments-count.component'
//import { EnrollmentsSummaryComponent } from './components/my-clients/enrollments-summary.component'
//import { EnrollmentDetailsComponent } from './components/my-clients/enrollment-details.component'

import { EnrollmentCountsReportComponent } from './components/clients-report/enrollment-counts-report.component'
import { EnrollmentSummaryReportComponent } from './components/clients-report/enrollment-summary-report.component'
import { EnrollmentDetailsReportComponent } from './components/clients-report/enrollment-details-report.component'
import { MedicareIDSearchComponent } from './components/clients-report/medicareid-search.component'

import { MultiSelectOrgSample } from './components/my-clients/multiselect-org-sample'
import { EnrollmentSearchComponent } from './components/enrollment-search/enrollment-search.component'
import { ExternalTrainingComponent } from './components/ExternalTraining/external-training.component'
import { UsersInactiveComponent } from './components/Users-Inactive/users-inactive.component'
import { UserProfileComponent } from './components/User-Profile/user-profile.component'
import { NewUsersAddedComponent } from './components/newusers-added/newusers-added.component'

import { NEJEClientsReportComponent } from './components/clients-report/neje/clients-report.component'
import { NEJEEnrollmentCountsReportComponent } from './components/clients-report/neje/enrollment-counts-report.component'
import { NEJEEnrollmentSummaryReportComponent } from './components/clients-report/neje/enrollment-summary-report.component'
import { NEJEEnrollmentDetailsReportComponent } from './components/clients-report/neje/enrollment-details-report.component'
import { NEJEMedicareIDSearchComponent } from './components/clients-report/neje/medicareid-search.component'

import { PWClientsReportComponent } from './components/pwmyclient/pwclients-report.component'
import { PWEnrollmentCountsReportComponent } from './components/pwmyclient/pwenrollment-counts-report.component'
import { PWEnrollmentSummaryReportComponent } from './components/pwmyclient/pwenrollment-summary-report.component'
import { PWEnrollmentDetailsReportComponent } from './components/pwmyclient/pwenrollment-details-report.component'
import { PWMedicareIDSearchComponent } from './components/pwmyclient/pwmedicareid-search.component'

import { SsMyClientsComponent } from './components/ss-my-clients/ss-my-clients.component'
import { SSMyClientsSummaryComponent } from './components/ss-my-clients/ss-my-clients-summary.component'
import { SSMyClientsDetailsComponent } from './components/ss-my-clients/ss-my-clients-details.component'
import { CanActivateGaurd } from '../auth/can-activate-gaurd'

export const routes: Routes = [
    {
        path: '',
        component: ReportsLayoutComponent,
        children: [
            {
                path: 'my-clients',
                component: ClientsReportComponent,
                children: [
                    {
                        path: 'counts',
                        component: EnrollmentCountsReportComponent
                    },
                    {
                        path: 'summary',
                        component: EnrollmentSummaryReportComponent
                    },
                    {
                        path: 'enrollment-details',
                        component: EnrollmentDetailsReportComponent
                    }
                ]
            },
            {
                path: 'ss-my-clients',
                component: SsMyClientsComponent
            },
            {
                path: 'ss-my-clients-summary',
                component: SSMyClientsSummaryComponent
            },
            {
                path: 'ss-my-clients-details',
                component: SSMyClientsDetailsComponent
            },
            {
                path: 'pwmy-clients',
                component: PWClientsReportComponent,
                children: [
                    {
                        path: 'counts',
                        component: PWEnrollmentCountsReportComponent
                    },
                    {
                        path: 'summary',
                        component: PWEnrollmentSummaryReportComponent
                    },
                    {
                        path: 'enrollment-details',
                        component: PWEnrollmentDetailsReportComponent
                    }
                ]
            },
            {
                path: 'pwmedicareid-search',
                component: PWMedicareIDSearchComponent
            },
            {
                path: 'multiselect-sample',
                component: MultiSelectOrgSample
            },
            {
                path: 'enrollment-search',
                component: EnrollmentSearchComponent
            },
            {
                path: 'medicareid-search',
                component: MedicareIDSearchComponent
            },
            {
                path: 'external-training',
                canActivate: [CanActivateGaurd],
                component: ExternalTrainingComponent
            },
            {
                path: 'neje-my-clients',
                component: NEJEClientsReportComponent,
                children: [
                    {
                        path: 'counts',
                        component: NEJEEnrollmentCountsReportComponent
                    },
                    {
                        path: 'summary',
                        component: NEJEEnrollmentSummaryReportComponent
                    },
                    {
                        path: 'enrollment-details/:source',
                        component: NEJEEnrollmentDetailsReportComponent
                    }
                    //,
                    //{
                    //    path: 'enrollment-details',
                    //    component: NEJEEnrollmentDetailsReportComponent
                    //}
                ]
            },
            {
                path: 'users-inactive',
                component: UsersInactiveComponent
            },
            {
                path: 'newusers-added',
                component: NewUsersAddedComponent
            },
            {
                path: 'neje-medicareid-search',
                component: NEJEMedicareIDSearchComponent
            },
            {
                path: 'users-profile',
                component: UserProfileComponent
            },
        ]
    }
]
